import React, { useEffect, useState } from 'react';
import {
  AddLogoImage,
  GetLogoImage,
  AddDrInfo,
  ADDTEMPLATESETTING,
  GetDoctorInfo,
  DeleteDrInfo,
  GetFontStyles
} from '../Services/Template';
import SpinnerModal from '../Spinner/SpinnerModal';
import { toast } from 'react-toastify';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Slide from '@mui/material/Slide';
import '../UI/TemplateModal.css';
import '../UI/Templatesetting.css';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  tableCellClasses,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Modal from 'react-bootstrap/Modal';
import Editor from './Editor/Editor';
import CustomTemp from './Editor/CustomeTemp';

// ================= TEMPLATE PREVIEW SETUP =================
import Template1 from '../Templates/Template1';
import Template2 from '../Templates/Template2';
import Template3 from '../Templates/Template3';
import Template4 from '../Templates/Template4';
import Template5 from '../Templates/Template5/Template5';
import Template6 from '../Templates/Template6/Template6 ';
import Template7 from '../Templates/Template7/Template7';

const TEMPLATE_COMPONENTS = {
  '1': Template1,
  '2': Template2,
  '3': Template3,
  '4': Template4,
  '5': Template5,
  '6': Template6,
  '7': Template7,
};

const DUMMY_REPORT_DATA = [
  {
    categorY_CODE: 'HEMATOLOGY',
    categorY_VALUE: 'Hematology',
    suB_CATEGORY_CODE: 'CBC',
    suB_CATEGORY_VALUE: 'Complete Blood Count',
    testName: 'Hemoglobin (HGB)',
    normalRange: '13.0 - 17.0',
    unit: 'g/dL',
    testResult: '14.2',
    comment: '',
    patientName: 'John Doe',
    patientID: '100234',
    age: 35,
    sex: 'Male',
    address: '123 Sample Street, Sample City',
    contactNumber: '+123 456 7890',
    referredBy: 'Dr. Sample',
    createdAt: new Date().toISOString(),
    laboratoryName: 'Sample Laboratory',
  },
  {
    categorY_CODE: 'HEMATOLOGY',
    categorY_VALUE: 'Hematology',
    suB_CATEGORY_CODE: 'CBC',
    suB_CATEGORY_VALUE: 'Complete Blood Count',
    testName: 'RBC Count',
    normalRange: '4.5 - 5.5',
    unit: 'million/µL',
    testResult: '4.95',
    comment: '',
    patientName: 'John Doe',
    patientID: '100234',
    age: 35,
    sex: 'Male',
    address: '123 Sample Street, Sample City',
    contactNumber: '+123 456 7890',
    referredBy: 'Dr. Sample',
    createdAt: new Date().toISOString(),
    laboratoryName: 'Sample Laboratory',
  },
  {
    categorY_CODE: 'HEMATOLOGY',
    categorY_VALUE: 'Hematology',
    suB_CATEGORY_CODE: 'CBC',
    suB_CATEGORY_VALUE: 'Complete Blood Count',
    testName: 'WBC Count',
    normalRange: '4.0 - 11.0',
    unit: '10³/µL',
    testResult: '7.25',
    comment: 'Sample comment for preview purposes.',
    patientName: 'John Doe',
    patientID: '100234',
    age: 35,
    sex: 'Male',
    address: '123 Sample Street, Sample City',
    contactNumber: '+123 456 7890',
    referredBy: 'Dr. Sample',
    createdAt: new Date().toISOString(),
    laboratoryName: 'Sample Laboratory',
  },
];

const DUMMY_QR_URL = 'https://example.com/verify/SAMPLE-REPORT-100234';

const TEMPLATE_OPTIONS = [
  { id: '1', label: 'Standard Header Template' },
  { id: '2', label: 'Premium Professional Template' },
  { id: '3', label: 'Minimal Report Template' },
  { id: '4', label: 'Modern Clinical Template' },
  { id: '5', label: 'Executive Report Template' },
  { id: '6', label: 'Classic Diagnostic Template' },
  { id: '7', label: 'Comprehensive Diagnostic Template' },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2c6bd7',
    color: theme.palette.common.white,
    fontFamily: '"-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue","sans-serif"',
    fontSize: 12,
    fontWeight: 600,
    padding: '8px 12px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontFamily: '"-apple-system","BlinkMacSystemFont","Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue","sans-serif"',
    fontSize: 12,
    padding: '8px 12px',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} timeout={500} />;
});

// Helper function to extract saved FontStyle from localStorage
const getSavedFontStyle = () => {
  try {
    const saved = localStorage.getItem('FontStyle');
    return saved ? JSON.parse(saved) : null;
  } catch (e) {
    console.error('Error parsing FontStyle from localStorage', e);
    return null;
  }
};

const TemplateSetting = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [image, setImage] = useState(null);
  const [TEMPValue, setTEMPValue] = useState('');
  const [DRINFOData, SetDRData] = useState([]);
  const [lgShow, setLgShows] = useState(false);
  const [isDelete, SetisDelete] = useState(false);
  const [DrID, setDRID] = useState(null);
  const [isDeleteSuccess, SetIsDeleteSuccess] = useState(false);
  const [boxBorderColor, setBoxBorderColor] = useState('lightgray');

  // Preview state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTemplateValue, setPreviewTemplateValue] = useState(null);

  // Doctor state
  const [Drdata, setDrdata] = useState({
    drname: '',
    designation: '',
    description: '',
    address: '',
    LaboratoryID: sessionStorage.getItem('LabID') || ''
  });

  // Load initial setting values from localStorage
  const savedSettings = getSavedFontStyle();

  // Fonts & Electronic Signature state bound with local storage defaults
  const [FONTSDATA, SETFONTSDATA] = useState({
    fontfamily: savedSettings?.fontfamily || 'sans-serif',
    fontsize: savedSettings?.fontsize || '12px',
    fontweight: savedSettings?.fontweight || 'normal',
    LabID: sessionStorage.getItem('LabID') || ''
  });

  const [electronicSignatureMsg, setElectronicSignatureMsg] = useState(
    savedSettings?.electronicSignatureMsg || 'This is a computer-generated report and does not require a physical signature.'
  );

  const FONTFAMILY = [
    { value: 'sans-serif', label: 'Helvetica' },
    { value: 'Arial, sans-serif', label: 'Arial' },
    { value: 'serif', label: 'Times New Roman' },
    { value: 'Georgia, serif', label: 'Georgia' },
    { value: 'monospace', label: 'Courier' },
    { value: 'fantasy', label: 'Luminari' },
    { value: 'cursive', label: 'Cursive' },
    { value: 'system-ui', label: 'System UI' },
  ];

  const FONTSIZE = [
    { value: '10px', label: '2xs (10px)' },
    { value: '12px', label: 'xs (12px)' },
    { value: '14px', label: 'sm (14px)' },
    { value: '16px', label: 'md (16px)' },
    { value: '18px', label: 'lg (18px)' },
    { value: '20px', label: 'xl (20px)' }
  ];

  const FONTWEIGHT = [
    { value: 'normal', label: 'Normal (400)' },
    { value: '500', label: 'Medium (500)' },
    { value: '600', label: 'Semi-Bold (600)' },
    { value: 'bold', label: 'Bold (700)' },
  ];

  // Seed inputs from the locally cached settings on first mount
  useEffect(() => {
    const localData = getSavedFontStyle();
    if (localData) {
      SETFONTSDATA(prev => ({
        ...prev,
        fontfamily: localData.fontfamily || prev.fontfamily,
        fontsize: localData.fontsize || prev.fontsize,
        fontweight: localData.fontweight || prev.fontweight,
      }));
      if (localData.electronicSignatureMsg !== undefined) {
        setElectronicSignatureMsg(localData.electronicSignatureMsg);
      }
    }
  }, []);

  // Load the persisted template settings from the server and hydrate the form.
  // Keeps localStorage in sync so every report template reflects the saved values.
  useEffect(() => {
    const fetchTemplateSettings = async () => {
      try {
        const LabID = sessionStorage.getItem('LabID');
        const res = await GetFontStyles(LabID);
        const setting = Array.isArray(res) ? res[0] : res;
        if (!setting) return;

        SETFONTSDATA(prev => ({
          ...prev,
          fontfamily: setting.fontfamily || prev.fontfamily,
          fontsize: setting.fontsize || prev.fontsize,
          fontweight: setting.fontweight || prev.fontweight,
        }));
        if (setting.electronicSignatureMsg) {
          setElectronicSignatureMsg(setting.electronicSignatureMsg);
        }
        localStorage.setItem('FontStyle', JSON.stringify(setting));
      } catch (error) {
        // Non-fatal: keep the locally cached values already loaded above
        console.error('Failed to load template settings', error);
      }
    };
    fetchTemplateSettings();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result);
      const img = new Image();
      img.src = reader.result;
      img.onload = () => {
        if (img.width > 650) {
          setBoxBorderColor('#56ea56');
        } else {
          setBoxBorderColor('red');
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleChange = (event) => {
    setTEMPValue(event.target.value);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      if (selectedFile) formData.append('file', selectedFile);
      formData.append('LabID', sessionStorage.getItem('LabID'));
      formData.append('TEMP', TEMPValue);

      const response = await AddLogoImage(formData);
      if (response) {
        toast.success("Template & Logo settings updated successfully");
      }
    } catch (error) {
      toast.error('Error uploading image/settings: ' + (error.message || error));
    } finally {
      setIsLoading(false);
    }
  };

  const getimage = async () => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem('LabID');
      const result = await GetLogoImage(LabID);
      setImage(result);
      if (result?.[0]?.selectedTemplate) {
        setTEMPValue(String(result[0].selectedTemplate));
      }
    } catch (error) {
      toast.error('Error loading template image data');
    } finally {
      setIsLoading(false);
    }
  };

  const GetDRInfo = async () => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem('LabID');
      const result = await GetDoctorInfo(LabID);
      SetDRData(result || []);
      SetIsDeleteSuccess(false);
    } catch (error) {
      toast.error('Error loading doctor info');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getimage();
  }, []);

  useEffect(() => {
    GetDRInfo();
  }, [isDeleteSuccess]);

  const onChangeDrData = (e) => {
    const { name, value } = e.target;
    setDrdata(prev => ({ ...prev, [name]: value }));
  };

  const SubmitDrData = async (e) => {
    e.preventDefault();
    if (!Drdata.drname || !Drdata.designation || !Drdata.description) {
      toast.warning('Please fill in all required doctor information');
      return;
    }

    setIsLoading(true);
    try {
      const response = await AddDrInfo(Drdata);
      if (response) {
        toast.success('Doctor info saved successfully');
        setDrdata({
          drname: '',
          designation: '',
          description: '',
          address: '',
          LaboratoryID: sessionStorage.getItem('LabID') || ''
        });
        SetIsDeleteSuccess(true);
      }
    } catch (error) {
      toast.error('Failed to save doctor info');
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeFONTS = (e) => {
    const { name, value } = e.target;
    SETFONTSDATA(prev => ({ ...prev, [name]: value }));
  };

  const saveFontsSetting = async () => {
    setIsLoading(true);
    try {
      const payload = {
        ...FONTSDATA,
        electronicSignatureMsg: electronicSignatureMsg.trim()
      };
      const res = await ADDTEMPLATESETTING(payload);
      if (res) {
        // Save full updated object to localStorage
        const savedObject = Array.isArray(res) ? res[0] : res;
        localStorage.setItem('FontStyle', JSON.stringify(savedObject || payload));

        toast.success('Font settings updated successfully');
      }
    } catch (error) {
      toast.error('Failed to update font settings');
    } finally {
      setIsLoading(false);
    }
  };

  // Handles saving Electronic Signature Message alongside Template Settings
  const saveElecSignatureSetting = async () => {
    if (!electronicSignatureMsg.trim()) {
      toast.warning('Please enter a valid electronic signature message.');
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        ...FONTSDATA,
        electronicSignatureMsg: electronicSignatureMsg.trim()
      };

      const res = await ADDTEMPLATESETTING(payload);
      if (res) {
        // Update LocalStorage upon success response
        const savedObject = Array.isArray(res) ? res[0] : res;
        localStorage.setItem('FontStyle', JSON.stringify(savedObject || payload));

        toast.success('Electronic signature message updated successfully!');
      }
    } catch (error) {
      toast.error('Failed to update electronic signature settings');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteDr = (id) => {
    setDRID(id);
    SetisDelete(!!id);
  };

  const DeleteDRInfos = async () => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem('LabID');
      const res = await DeleteDrInfo(LabID, DrID);
      if (res) {
        toast.success("Doctor Info Deleted!");
        SetIsDeleteSuccess(true);
      }
    } catch (error) {
      toast.error('Error deleting record');
    } finally {
      SetisDelete(false);
      setIsLoading(false);
    }
  };

  const handleClose = () => SetisDelete(false);

  const handleEditorImage = (imageBase64) => {
    setPreviewImage(imageBase64);
    const blob = dataURLtoBlob(imageBase64);
    const file = new File([blob], 'editor-image.png', { type: 'image/png' });
    setSelectedFile(file);
  };

  function dataURLtoBlob(dataUrl) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const getRawBase64 = (value) => {
    if (!value) return null;
    return value.includes(',') ? value.split(',')[1] : value;
  };

  const handlePreview = (templateValue) => {
    if (!templateValue) return;

    const rawLogo = previewImage
      ? getRawBase64(previewImage)
      : image?.[0]?.data
        ? getRawBase64(image[0].data)
        : null;

    if (rawLogo) {
      localStorage.setItem('LogoImage', rawLogo);
    }

    setPreviewTemplateValue(String(templateValue));
    setPreviewOpen(true);
  };

  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewTemplateValue(null);
  };

  const PreviewComponent = previewTemplateValue ? TEMPLATE_COMPONENTS[previewTemplateValue] : null;

  return (
    <>
      {isLoading && <SpinnerModal isLoading={true} />}

      <div className='container-fluid Container2 p-3 common-FontFamily'>
        {/* TOP SECTION: Template Selection & Header Logo Upload */}
        <div className='common-box-shadow common-bg-white common-br-3px p-3 mb-3'>
          <form onSubmit={handleUpload}>
            <div className="mb-2">
              <h6 className="common-FontSize-small common-FontWeight common-color mb-1">
                Select Layout Template
              </h6>
              <div className="template-selection-list">
                {TEMPLATE_OPTIONS.map((item) => (
                  <div key={item.id} className="template-radio-item d-flex align-items-center justify-content-between py-1 px-2 border-bottom">
                    <div className="form-check m-0">
                      <input
                        value={item.id}
                        className="form-check-input common-cursor"
                        type="radio"
                        name="flexRadioDefault"
                        id={`template-${item.id}`}
                        checked={TEMPValue === item.id}
                        onChange={handleChange}
                      />
                      <label className="form-check-label common-FontSize-small common-cursor ms-1" htmlFor={`template-${item.id}`}>
                        {item.label}
                      </label>
                    </div>
                    <button type="button" className="template-preview-link" onClick={() => handlePreview(item.id)}>
                      <VisibilityIcon fontSize="small" /> Preview
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* Header Image Canvas & Upload */}
            <div className="mt-3">
              <span style={{ color: boxBorderColor }} className='common-FontSize-small d-block mb-1'>
                Note: Recommended header width is &gt; 650px. Images outside aspect ratios may appear stretched.
              </span>
              
              <div className="header-preview-box mb-2" style={{ borderColor: boxBorderColor }}>
                {previewImage ? (
                  <img src={previewImage} alt='Header Preview' className="header-preview-img" />
                ) : image?.[0]?.data ? (
                  <img src={"data:image/png;base64," + image[0].data} alt='Header Preview' className="header-preview-img" />
                ) : (
                  <div className="d-flex align-items-center justify-content-center h-100 text-muted common-FontSize-small">
                    No Header/Logo Uploaded
                  </div>
                )}
              </div>

              <div className='d-flex flex-wrap align-items-center gap-2'>
                <input type="file" onChange={handleFileChange} className="form-control form-control-sm common-Input" style={{ maxWidth: '280px' }} />
                <Button type='submit' variant="contained" className="common-button">Update Template</Button>
                <Button type='button' onClick={() => setLgShows(true)} variant="contained" className="common-button">Design Header</Button>
                <Button type='button' onClick={() => handlePreview(TEMPValue)} variant="contained" className="common-button">Preview Selected</Button>
              </div>
            </div>
          </form>
        </div>

        {/* MIDDLE SECTION: Typography & Font Settings */}
        <div className='row mb-3'>
          <div className='col-12 col-md-6'>
            <div className='common-box-shadow common-bg-white common-br-3px p-3 h-100'>
              <h6 className="common-FontSize-small common-FontWeight mb-1">
                Font & Layout Formatting
              </h6>
              <hr className="my-2" />

              <div className="row g-2 align-items-center mb-2">
                <div className='col-sm-4'>
                  <label className='common-Labels' htmlFor="FONTFAMILY">Font Family</label>
                </div>
                <div className='col-sm-8'>
                  <select
                    className="form-select common-Input"
                    id='FONTFAMILY'
                    name='fontfamily'
                    onChange={onChangeFONTS}
                    value={FONTSDATA.fontfamily}
                  >
                    {FONTFAMILY.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row g-2 align-items-center mb-2">
                <div className='col-sm-4'>
                  <label className='common-Labels' htmlFor="FONTSIZE">Font Size</label>
                </div>
                <div className='col-sm-8'>
                  <select
                    className="form-select common-Input"
                    id='FONTSIZE'
                    name='fontsize'
                    onChange={onChangeFONTS}
                    value={FONTSDATA.fontsize}
                  >
                    {FONTSIZE.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row g-2 align-items-center mb-3">
                <div className='col-sm-4'>
                  <label className='common-Labels' htmlFor="FONTWEIGHT">Font Style</label>
                </div>
                <div className='col-sm-8'>
                  <select
                    className="form-select common-Input"
                    id='FONTWEIGHT'
                    name='fontweight'
                    onChange={onChangeFONTS}
                    value={FONTSDATA.fontweight || 'normal'}
                  >
                    {FONTWEIGHT.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Live preview of the selected typography */}
              <div className="mb-3">
                <label className='common-Labels d-block mb-1'>Preview</label>
                <div
                  className="border common-br-3px p-2"
                  style={{
                    background: '#f8f9fa',
                    fontFamily: FONTSDATA.fontfamily,
                    fontSize: FONTSDATA.fontsize,
                    fontWeight: FONTSDATA.fontweight || 'normal',
                    lineHeight: 1.5,
                  }}
                >
                  <div>Hemoglobin (HGB) &nbsp; 14.2 g/dL &nbsp; (13.0 - 17.0)</div>
                  <div>Patient: John Doe &nbsp;|&nbsp; Age/Sex: 35 / Male</div>
                  <div>The quick brown fox jumps over the lazy dog 0123456789</div>
                </div>
              </div>

              <div>
                <Button type='button' onClick={saveFontsSetting} variant="contained" className="common-button ms-0">
                  Save Font Settings
                </Button>
              </div>
            </div>
          </div>

          <div className='col-12 col-md-6'>
            <div className='common-box-shadow common-bg-white common-br-3px p-3 h-100 d-flex flex-column justify-content-between'>
              <div>
                <h6 className="common-FontSize-small common-FontWeight mb-1">
                  Electronic Signature Message
                </h6>
                <hr className="my-2" />

                {/* Note Banner */}
                <div className="alert alert-info py-2 px-3 mb-3 common-FontSize-small" role="alert" style={{ fontSize: '11px', borderRadius: '4px' }}>
                  <strong>Note:</strong> This custom disclaimer message will be rendered directly above or alongside the digital signature section on generated PDF reports.
                </div>

                <div className="mb-3">
                  <label className='common-Labels d-block mb-1' htmlFor="elecSignature">
                    Disclaimer Text
                  </label>
                  <textarea
                    id="elecSignature"
                    rows="3"
                    className="form-control common-Input"
                    placeholder="Enter electronic signature disclaimer statement..."
                    value={electronicSignatureMsg}
                    onChange={(e) => setElectronicSignatureMsg(e.target.value)}
                  />
                </div>
              </div>

              <div>
                <Button type='button' onClick={saveElecSignatureSetting} variant="contained" className="common-button ms-0">
                  Save Electronic Signature Settings
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* BOTTOM SECTION: Doctor Information Details */}
        <div className='common-box-shadow common-bg-white common-br-3px p-3'>
          <h6 className="common-FontSize-small common-FontWeight mb-1">
            Doctor Information <span className="text-muted fw-normal">(Required for Premium Templates)</span>
          </h6>
          <hr className="my-2" />

          <form onSubmit={SubmitDrData}>
            <div className="row g-2">
              <div className="col-12 col-sm-6 col-md-3">
                <label className='common-Labels' htmlFor="drname">Doctor Name <span className="common-Asterisk">*</span></label>
                <input
                  className="form-control common-Input"
                  id='drname'
                  name='drname'
                  onChange={onChangeDrData}
                  value={Drdata.drname}
                  required
                />
              </div>

              <div className="col-12 col-sm-6 col-md-3">
                <label className='common-Labels' htmlFor="designation">Designation <span className="common-Asterisk">*</span></label>
                <input
                  className="form-control common-Input"
                  id='designation'
                  name='designation'
                  onChange={onChangeDrData}
                  value={Drdata.designation}
                  required
                />
              </div>

              <div className="col-12 col-sm-6 col-md-3">
                <label className='common-Labels' htmlFor="description">Description <span className="common-Asterisk">*</span></label>
                <input
                  className="form-control common-Input"
                  id='description'
                  name='description'
                  onChange={onChangeDrData}
                  value={Drdata.description}
                  required
                />
              </div>

              <div className="col-12 col-sm-6 col-md-3">
                <label className='common-Labels' htmlFor="address">Address</label>
                <input
                  className="form-control common-Input"
                  id='address'
                  name='address'
                  onChange={onChangeDrData}
                  value={Drdata.address}
                />
              </div>
            </div>

            <div className="mt-2">
              <Button type='submit' variant="contained" className="common-button ms-0">Save Doctor Record</Button>
            </div>
          </form>

          {/* Doctor Records Table */}
          <div className="mt-3 table-responsive">
            <Table size="small" aria-label="doctor info table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Dr. Name</StyledTableCell>
                  <StyledTableCell>Designation</StyledTableCell>
                  <StyledTableCell>Description</StyledTableCell>
                  <StyledTableCell align="center">Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {DRINFOData.length > 0 ? (
                  DRINFOData.map((data, index) => (
                    <StyledTableRow key={data.drid || index}>
                      <StyledTableCell>{data.drname}</StyledTableCell>
                      <StyledTableCell>{data.designation}</StyledTableCell>
                      <StyledTableCell>{data.description}</StyledTableCell>
                      <StyledTableCell align="center">
                        <Button
                          onClick={() => handleDeleteDr(data.drid)}
                          type='button'
                          variant="contained"
                          className="Delete-Action-Button"
                        >
                          Delete
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={4} align="center" className="text-muted">
                      No doctor information records found.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Dialog
        PaperProps={{ style: { borderRadius: '0px', padding: '10px' } }}
        open={isDelete}
        keepMounted
        onClose={handleClose}
        className='common-modal'
        TransitionComponent={Transition}
      >
        <div style={{ textAlign: 'end' }}>
          <button className='common-cross-button' onClick={handleClose} type="button">
            <CloseRoundedIcon />
          </button>
        </div>
        <DialogTitle style={{ textAlign: 'center' }} className='common-FontFamily'>
          <CancelOutlinedIcon style={{ fontSize: '80px', color: '#dc2626' }} /><br />
          <h4 className="mt-2">Are you sure?</h4>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" style={{ textAlign: 'center' }}>
            <span>Do you really want to delete this doctor record?</span><br />
            <span>This process cannot be undone.</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button onClick={handleClose} variant="contained" type='button' className="dialog-Cancel-button">Cancel</Button>
          <Button onClick={DeleteDRInfos} variant="contained" type='button' className="dialog-Delete-button">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* Custom Template Editor Modal */}
      <Modal size="xl" show={lgShow} onHide={() => setLgShows(false)} dialogClassName="modal-90w">
        <Modal.Header className='d-flex align-items-center justify-content-between'>
          <Modal.Title className='common-FontSize-small common-FontWeight'>
            Header Canvas Designer
          </Modal.Title>
          <button className="common-cross-button" onClick={() => setLgShows(false)} type="button">
            <CloseRoundedIcon />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Editor onPreviewGenerated={handleEditorImage} />
        </Modal.Body>
      </Modal>

      {/* Template Full-Screen Preview Dialog */}
      <Dialog
        open={previewOpen}
        onClose={closePreview}
        maxWidth="lg"
        fullWidth
        PaperProps={{ style: { borderRadius: '4px' } }}
      >
        <DialogTitle style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span className="common-FontSize-small common-FontWeight">
            Template Preview {previewTemplateValue ? `— Template ${previewTemplateValue}` : ''}
          </span>
          <button className='common-cross-button' onClick={closePreview} type="button">
            <CloseRoundedIcon />
          </button>
        </DialogTitle>
        <DialogContent dividers style={{ backgroundColor: '#f0f2f5' }}>
          <div className="template-preview-page">
            {PreviewComponent ? (
              <PreviewComponent reportData={DUMMY_REPORT_DATA} QRurl={DUMMY_QR_URL} />
            ) : (
              <p className="common-FontSize-small common-FontFamily text-center py-4 text-muted">
                No preview component configured for this template option.
              </p>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TemplateSetting;